import { StyleSheet, View, Text } from '@react-pdf/renderer'
import React from 'react'

const TableFooter: React.FC = () => {

    const styles = StyleSheet.create({
        container: {
            position: 'absolute',
            bottom: '18px',
            left: '20px',
            right: '20px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            width: '100%',
            borderTop: '1px solid black',
        },
        leftText: {
            fontSize: '8px',
        },
        rightText: {
            fontSize: '8px',
            fontWeight: 'bold',
        }
    })


    return(
<>
<Text fixed wrap={false} style={{ bottom: '30px',fontSize:'8px', position: 'absolute', left: '40%', marginTop: '48px'}}>010_FMEI Rev.08 - Apr. Nov/23</Text>
    <View style = {styles.container} fixed>

        <Text style = {styles.leftText} render={({ pageNumber, totalPages }) => (`pág ${pageNumber} de ${totalPages}`)} fixed />
    </View>

        <View style = {{marginTop: '48px'}}>
            <Text style = {{borderBottom: '1px solid black',marginTop: '5px', marginBottom: '5px', fontSize: '10px'}}><b>OBSERVAÇÕES:</b> </Text>
            <Text style = {{marginTop: '5px', marginBottom: '5px', fontSize: '10px'}}>1) Obs 1: Parâmetros marcados com * são provenientes de amostras compostas, ou seja, formadas por de mais de uma alíquota coletada no mesmo local de coleta;</Text>
            <Text style = {{marginBottom: '5px', fontSize: '10px'}}>2) Obs 2: Amostras pontuais são formadas por alíquotas únicas;</Text>
            <Text style = {{marginBottom: '5px', fontSize: '10px'}}>3) Obs 3: Para as amostras compostas, a data de coleta aponta a coleta da primeira alíquota, sendo a coleta da última alíquota realizada no dia seguinte.</Text>
        </View>
        </>
    )

}

export default TableFooter